module.exports = __webpack_public_path__ + "img/suche.43e9ec54.svg";